// Try to import the APK, but don't fail if it's not available
let SlickScanAndroid;
try {
    SlickScanAndroid = require('./slick-scan-android.apk');
} catch (e) {
    console.warn('SlickScan Android APK not found. This is expected in development.');
    SlickScanAndroid = null;
}

export { SlickScanAndroid };